import { __rest } from "tslib";
import dayjs from 'dayjs';
import groupBy from 'lodash/groupBy';
import * as DateString from '../DateString';
import * as DateTimeInterval from '../DateTimeInterval';
export const breakCases = (specialCases) => {
    const { open, closed } = groupByClosed(specialCases);
    const normalizeCases = (cases) => groupByDay(cases.map(DateTimeInterval.fromSpecialCase).flatMap(breakInterval));
    return { open: normalizeCases(open), closed: normalizeCases(closed) };
};
const groupByClosed = (specialCases) => (Object.assign({ open: [], closed: [] }, groupBy(specialCases, ({ isClosed }) => (isClosed ? 'closed' : 'open'))));
const groupByDay = (intervals) => {
    const map = {};
    intervals.forEach((_a) => {
        var { day } = _a, timeInterval = __rest(_a, ["day"]);
        if (!map[day]) {
            map[day] = [];
        }
        map[day].push(timeInterval);
    });
    return map;
};
const iterator = {
    next: (dateTime) => DateString.fromDate(dayjs.utc(dateTime).add(1, 'd')),
    prev: (dateTime) => DateString.fromDate(dayjs.utc(dateTime).subtract(1, 'd')),
    distance: (a, b) => Math.abs(dayjs.utc(a).diff(dayjs.utc(b), 'd')),
};
const breakInterval = DateTimeInterval.breakInterval(iterator);
//# sourceMappingURL=SpecialCase.js.map